import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Table,
  Form,
  Input,
  Button,
  Modal,
  Skeleton,
  Spin,
  Result,
} from "antd";
import { useDispatch } from "react-redux";
import { useTypedSelector } from "../../store";
import {
  getLevelRequest,
  createLevelRequest,
  updateLevelRequest,
  resetSuccessLevel,
  resetMessageLevel,
} from "../../slices/level"; // Sesuaikan dengan nama slice level
import { LoadingOutlined } from "@ant-design/icons";

const LevelSetting: React.FC = () => {
  const dispatch = useDispatch();
  const [formAdd] = Form.useForm();
  const [formEdit] = Form.useForm();
  const [isEditing, setIsEditing] = useState(false);
  const [editingLevel, setEditingLevel] = useState<any>(null);
  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState<any>(null);
  const [isAddMode, setIsAddMode] = useState(false);

  const {
    levelList,
    loading,
    isSuccess,
    messageErr,
    isUpdate,
    isCreate,
  } = useTypedSelector((state) => ({
    levelList: state.Level.levelList, // Sesuaikan dengan reducer level
    loading: state.Level.pageIsLoading,
    isSuccess: state.Level.isSuccess,
    messageErr: state.Level.message,
    isUpdate: state.Level.levelUpdate,
    isCreate: state.Level.levelPost,
  }));

  useEffect(() => {
    dispatch(getLevelRequest() as any);
  }, [isUpdate, isCreate]);

  useEffect(() => {
    if (editingLevel) {
      formEdit.setFieldsValue(editingLevel);
    }
  }, [editingLevel]);

  const columns = [
    {
      title: "No",
      dataIndex: "no",
      key: "no",
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: "Level Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Action",
      key: "action",
      render: (_: any, record: any) => (
        <Button
          type="primary"
          style={{ backgroundColor: "#faad14", borderColor: "#faad14" }}
          onClick={() => handleEdit(record)}
        >
          Edit
        </Button>
      ),
    },
  ];

  const handleEdit = (level: any) => {
    setEditingLevel(level);
    setIsEditing(true);
  };

  const handleCancel = () => {
    setIsEditing(false);
    setEditingLevel(null);
    setOpenModal(false);
    dispatch(resetMessageLevel());
    dispatch(resetSuccessLevel());
    formAdd.resetFields();
    formEdit.resetFields();
  };

  const showConfirmationModal = (values: any, isAdd: boolean) => {
    setModalData(values);
    setIsAddMode(isAdd);
    setOpenModal(true);
  };

  const handleModalOk = () => {
    if (isAddMode) {
      onFinish(modalData);
    } else {
      onFinishUpdate(modalData);
    }
  };

  const onFinish = (values: any) => {
    dispatch(createLevelRequest(values) as any);
  };

  const onFinishUpdate = (values: any) => {
    dispatch(updateLevelRequest({ ...editingLevel, ...values }) as any);
  };

  return (
    <div style={{ marginTop: 20 }}>
      <Row gutter={16}>
        <Col span={16}>
          {!loading ? (
            <Table columns={columns} dataSource={levelList} rowKey="_id" />
          ) : (
            <Skeleton active />
          )}
        </Col>

        <Col span={8}>
          <div
            style={{
              backgroundColor: "#EEEEEE",
              marginBottom: 2,
              marginLeft: 10,
              borderColor: "#eaeaea",
              borderStyle: "solid",
              borderRadius: "7px",
              padding: 20,
            }}
          >
            <h4>Add Level</h4>
            <Form
              form={formAdd}
              layout="vertical"
              onFinish={(values) => showConfirmationModal(values, true)}
              style={{ maxWidth: 400, margin: "0 auto" }}
            >
              <Form.Item
                label="Level Name"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Please input the level name!",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ marginRight: 20 }}
                >
                  Submit
                </Button>
                <Button onClick={handleCancel}>Cancel</Button>
              </Form.Item>
            </Form>
          </div>

          {isEditing && (
            <div
              style={{
                backgroundColor: "#E4E0E1",
                marginTop: 15,
                marginLeft: 10,
                borderColor: "#eaeaea",
                borderStyle: "solid",
                borderRadius: "7px",
                padding: 20,
              }}
            >
              <h4>Edit Level</h4>
              <Form
                form={formEdit}
                layout="vertical"
                onFinish={(values) =>
                  showConfirmationModal(
                    { ...editingLevel, ...values },
                    !isEditing
                  )
                }
                initialValues={editingLevel || {}}
                style={{ maxWidth: 400, margin: "0 auto" }}
              >
                <Form.Item
                  label="Level Name"
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Please input the level name!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{
                      marginRight: 20,
                      backgroundColor: "#faad14",
                      borderColor: "#faad14",
                    }}
                  >
                    Update
                  </Button>
                  <Button onClick={handleCancel}>Cancel & Close</Button>
                </Form.Item>
              </Form>
            </div>
          )}
        </Col>
      </Row>

      <Modal
        open={openModal}
        title="Confirm Action"
        onCancel={handleCancel}
        cancelText="Close"
        onOk={handleModalOk}
        okButtonProps={
          isSuccess || messageErr.length > 0
            ? { style: { display: "none" } }
            : {}
        }
      >
        <p>
          {isAddMode
            ? "Are you sure you want to add this level?"
            : "Are you sure you want to edit this level?"}
        </p>
        {loading && (
          <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
        )}
        {isSuccess && (
          <Result status="success" title="Successfully to Request" />
        )}
        {messageErr.length > 0 && (
          <Result status="warning" title={messageErr} />
        )}
      </Modal>
    </div>
  );
};

export default LevelSetting;

